import reportFilename from "../reportFilename";
import buildAcrYamlModel from "./buildAcrYamlModel";
import serializeAcrYaml from "./serializeAcrYaml";

export default function downloadAcrYaml(evaluation, catalog) {
  const model = buildAcrYamlModel(evaluation, catalog);
  const yamlString = `${serializeAcrYaml(model)}\n`;
  const blob = new Blob([yamlString], { type: "application/x-yaml;charset=utf-8" });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = `${reportFilename(evaluation)}.yaml`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}
